<template>
  <div :class="postAlert" :style="style">
    <span class="msg">Sucesso: {{message}}</span>
    <div class="close-btn" v-on:click="closeAlert">
      <span class="fas">x</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessAlert",
  props: {
    message: String,
    duration: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      postAlert: "alert hide",
      style: "",
      hideTimer: null,
    };
  },
  beforeDestroy() {
    this.clearHideTimer();
  },
  methods: {
    clearHideTimer() {
      if (!this.hideTimer) return;
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    },
    alert() {
      this.clearHideTimer();
      this.postAlert = "alert show showAlert";
      this.style = "right: 20px;";
      if (this.duration > 0) {
        this.hideTimer = setTimeout(() => this.closeAlert(), this.duration);
      }
    },
    closeAlert() {
      this.clearHideTimer();
      this.postAlert = "alert hide";
      this.style = "";
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap');
*{
  margin: 0;
  padding: 0;
  user-select: none;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}
.alert{
  background: #81c784;
  padding: 20px 40px 20px 0;
  min-width: 260px;
  position: absolute;
  bottom: 50px;
  border-radius: 4px;
  border-left: 8px solid #4caf50;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
.alert.showAlert{
  opacity: 1;
  pointer-events: auto;
}
.alert.show{
  animation: show_slide 1s ease forwards;
}
.alert .msg{
  padding: 0 20px;
  font-size: 18px;
  color: #ffffff;
}
.alert .close-btn{
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  background: #4caf50;
  padding: 20px 18px;
  cursor: pointer;
}
.alert .close-btn:hover{
  background: #3f9943;
}
.alert .close-btn .fas{
  color:#1e6822;
  font-size: 22px;
  line-height: 40px;
}
@keyframes show_slide {
  0%{
    transform: translateX(100%);
  }
  40%{
    transform: translateX(-10%);
  }
  80%{
    transform: translateX(0%);
  }
  100%{
    transform: translateX(-10px);
  }
}
.alert.hide{
  animation: hide_slide 1s ease forwards;
}
@keyframes hide_slide {
  0%{
    transform: translateX(-10px);
  }
  40%{
    transform: translateX(0%);
  }
  80%{
    transform: translateX(-10%);
  }
  100%{
    transform: translateX(100%);
  }
}
@media screen and (max-width: 430px) {
  .alert .msg{
    padding: 0 20px;
    padding-left: 10px;
    font-size: 14px;
    color: #ffffff;
  }
}
@media screen and (max-width: 360px) {
  .alert .msg{
    padding: 0 20px;
    padding-left: 10px;
    font-size: 12px;
    color: #ffffff;
  }
}
</style>